/**
 * «Юниверситет» (28.09): настоящие данные вместо демо макета («ГРЕЙД II», «7 / 20»).
 *  - грейд — /api/grades/my по квестам ЭТОГО филиала, «если квестов несколько, берём
 *    максимальный»; нет грейда → «Грейд не присвоен» без бейджа;
 *  - игры — /api/grades/my-played: одно число, сумма по квестам филиала, «без порогов и
 *    полосок до следующего грейда» (ТЗ). Грейд в этой версии ничего не открывает.
 */
import { useEffect, useState } from "react";
import { api } from "../../../api/client";

/** undefined — грузится; null — не удалось загрузить */
export interface UniStats {
  grade: number | null | undefined; // 0 — не присвоен
  played: number | null | undefined;
}

interface GradeRow { quest_id: string; grade: number | string }
interface PlayedRow { quest_id: string; n: number | string }

export function useUniStats(questIds: string[]): UniStats {
  const key = questIds.join("|");
  const [grade, setGrade] = useState<UniStats["grade"]>(undefined);
  const [played, setPlayed] = useState<UniStats["played"]>(undefined);

  useEffect(() => {
    let alive = true;
    const ids = new Set(key ? key.split("|") : []);
    setGrade(undefined);
    setPlayed(undefined);
    api<{ results?: GradeRow[] }>("/api/grades/my")
      .then((r) => {
        const gs = (r.results ?? []).filter((x) => ids.has(x.quest_id)).map((x) => Number(x.grade) || 0);
        if (alive) setGrade(Math.max(0, ...gs));
      })
      .catch(() => { if (alive) setGrade(null); });
    api<{ results?: PlayedRow[] }>("/api/grades/my-played")
      .then((r) => {
        const n = (r.results ?? []).filter((x) => ids.has(x.quest_id)).reduce((sum, x) => sum + (Number(x.n) || 0), 0);
        if (alive) setPlayed(n);
      })
      .catch(() => { if (alive) setPlayed(null); });
    return () => { alive = false; };
  }, [key]);

  return { grade, played };
}
